export function getEtimClassNamesFromList(etimCodes: string[]): string[] {
  const regex = /^([ET]C[0-9]{6})-/;

  const foundClasses = etimCodes
    .map((etimCode) => etimCode.replace('named_tags.', ''))
    .filter((etimCode) => etimCode.match(regex))
    .map((etimCode) => (etimCode.match(regex) as RegExpMatchArray)[1]);

  return [...new Set(foundClasses)];
}
